"use strict";

var _classCallCheck = require("/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Validator = /*#__PURE__*/function () {
  function Validator(validatorFunction, displayPropertiesValues) {
    _classCallCheck(this, Validator);
    this.validatorFunction = validatorFunction;
    this.displayPropertiesValues = displayPropertiesValues;
  }
  return _createClass(Validator, [{
    key: "displayProperties",
    get: function get() {
      return this.displayPropertiesValues || {};
    }
  }, {
    key: "displayPropertiesList",
    get: function get() {
      if (this.displayPropertiesValues) {
        return Object.keys(this.displayPropertiesValues) || [];
      } else {
        return [];
      }
    }
  }, {
    key: "run",
    value: function run(value, properties) {
      return this.validatorFunction(value, properties);
    }
  }]);
}();
exports.default = Validator;